import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';

export default function AdminLogin() {
  const { login } = useAdmin();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__box">
        <div className="admin-login__brand">
  <img
    src="/anns-logo.png"
    alt="ANN'S"
    className="admin-login__brand-logo"
  />
  <h1 className="admin-login__title">ANN'S Admin</h1>
  <p className="admin-login__sub">Beauty Parlour Dashboard</p>
</div>
        {error && <div className="admin-alert admin-alert--err">{error}</div>}
        <form onSubmit={handleSubmit} className="admin-login__form">
          <div className="admin-fg">
            <label className="admin-fl">Email</label>
            <input type="email" className="admin-fi" value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              placeholder="admin@annsbeauty.in" required autoFocus />
          </div>
          <div className="admin-fg">
            <label className="admin-fl">Password</label>
            <input type="password" className="admin-fi" value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              placeholder="••••••••" required />
          </div>
          <button type="submit" className="admin-btn admin-btn--primary admin-btn--full" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
